module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-138.ea2d38f3.svg";